import { createContext, useContext, useMemo, useState } from "react";

import type { Dispatch, ReactNode, SetStateAction } from "react";

// Which row of the transactions table is currently expanded. Isolated so that moving
// the selection only repaints the table cells, not the whole page.
type ActiveTransactionValue = {
  activeTransaction: unknown;
  setActiveTransaction: Dispatch<SetStateAction<unknown>>;
};

const ActiveTransactionContext = createContext<ActiveTransactionValue | null>(null);

ActiveTransactionContext.displayName = "ActiveTransactionContext";

function ActiveTransactionProvider({ children }: { children: ReactNode }) {
  const [activeTransaction, setActiveTransaction] = useState<unknown>(null);

  const value = useMemo(
    () => ({
      activeTransaction: activeTransaction,
      setActiveTransaction: setActiveTransaction,
    }),
    [activeTransaction]
  );

  return (
    <ActiveTransactionContext.Provider value={value}>{children}</ActiveTransactionContext.Provider>
  );
}

function useActiveTransaction(): ActiveTransactionValue {
  const context = useContext(ActiveTransactionContext);

  if (!context) {
    throw new Error("useActiveTransaction must be used inside AppProvider.");
  }

  return context;
}

export { ActiveTransactionProvider, useActiveTransaction };
